/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */

import React, { useEffect, useState, useCallback } from 'react';
import EmptyAddScreen from '../../../../components/EmptyAddScreen'
import Table from './Components/Table'
import {  useSearchParams } from 'react-router-dom'
import TopBar from '../../../../components/TopBar'
import Debounce from '../../../../CommonMethods/Debounce';
import moment from 'moment';
import { dataService } from '../../../../services/data.services';
import Shimmer from '../../../../components/Shimmer/itemShimmer'
import SearchEmptyScreen from '../../../../components/SearchEmptyScreen';
import { GetBranchId } from '../../../../CommonMethods/GetBranchId';
import Toast from '../../../../components/Toast';

export default function InwardList({searchParams, setSearchParams}) {
    const [loading, setLoading] = useState(true);
    const [FilterData, setFilterData] = useState({date_range : []});
    const [FilterCheckbox, setFilterCheckBox] = useState({})
    const [filterCount, setFilterCount] = useState(0)
    const [searchFieldDebounce, setsearchFieldDebounce] = useState(searchParams.get('search') === null ? '' : decodeURIComponent(searchParams.get('search')));
    const [inwardTransferStudentList, setInwardTransferStudentList] = useState([])
    const [inwardTransferStudentCount, setInwardTransferStudentCount] = useState(0)
    const [inwardTransferStudentTotalCount, setInwardTransferStudentTotalCount] = useState(0)
    const [toastErrorMessage, setToastErrorMessage] = useState("")

    /**
     * The function `getCount` counts the number of non-empty values in the `FilterCheckbox` object and
     * updates the `filterCount` state variable accordingly.
     */
    const getCount = (type) => {
        let count = 0
        const hasStartDate = FilterCheckbox.hasOwnProperty('start_date');
        Object.keys(FilterCheckbox).map((item) =>  {
            if(FilterCheckbox[item] && FilterCheckbox[item]?.length !== 0 && item !="end_date") {
                count += 1
            }
            if (item === "end_date" && !hasStartDate){
                count += 1
            }
        })
        if(type) {
            setFilterCount(count)
        } else {
            setFilterCount(0)
        }
    }

    /**
     * The function `handleSearchParams` updates the search parameters object by adding or modifying a
     * key-value pair, and then sets the updated search parameters.
     */
    const handleSearchParams = (key, value) => {
        // setLoading(true);
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        if(key === 'search') {params[key] = encodeURIComponent(value); }
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params})
    }

    /* The `optimizedFn` constant is a memoized version of the `Debounce` function. It is created using
    the `useCallback` hook. */
    const optimizedFn = useCallback(
        Debounce((key, value) => handleSearchParams(key,value)),
        [searchParams]
    );

    /**
     * The function `updateFilterCheckBox` creates an object with non-null properties from searchParams,
     * filters out null or undefined values, updates the state with the filtered values, and counts the
     * number of filtered values.
     */
    const updateFilterCheckBox = () => {
        // Create an object with non-null properties from searchParams
        const filterState = {
            start_date: searchParams.get('start_date'),
            end_date: searchParams.get('end_date'),
        };
        // Filter out null or undefined values
        const filteredFilterState = Object.fromEntries(
            Object.entries(filterState).filter(([_, value]) => value !== null && value !== undefined)
        );
    
        // Update the state with the filtered values
        setFilterCheckBox(filteredFilterState);
        const hasStartDate = filteredFilterState.hasOwnProperty('start_date');
        let count = 0
        Object.keys(filteredFilterState).map((item) =>  {
            if(filteredFilterState[item] &&filteredFilterState[item]?.length !== 0  && item !="end_date") {
                count += 1
            }
            if (item === "end_date" && !hasStartDate){
                count += 1
            }
        })
        setFilterCount(count)
    };

    /**
     * The function `handleApplyFilter` is used to apply filters to a search query and update the search
     * parameters accordingly.
     */
    const handleApplyFilter = (type) => {
        let params = Object.fromEntries(searchParams);
        if(type) {
            let flag = true;
            params["filter"] = true
            params.page_number = 1
            Object.keys(FilterCheckbox).map((item) => {
                let val = ""
                if((item === 'start_date' || item === 'end_date') && FilterCheckbox[item]!==null) {
                    let val = FilterCheckbox[item]
                    params[item] = searchParams.get(item) !== val ? moment(val.$d).format("YYYY-MM-DD") : val
                    setSearchParams({ ...params})
                    flag = false
                } else if(FilterCheckbox[item] && FilterCheckbox[item]?.length !== 0 ) {
                    FilterCheckbox[item].map((key) => {
                        val += `${key},`
                    })
                    params[item] = val.slice(0, -1)
                    setSearchParams({ ...params})
                    flag = false
                } else {
                    delete params[item] 
                    setSearchParams({ ...params})  
                }
                if(flag) {
                    delete params.filter
                    setSearchParams({ ...params})  
                }
            })
        } else {
            delete params.filter
            Object.keys(FilterCheckbox).map((item) => {
                delete params[item]
            })
            delete params.start_date
            delete params.end_date
            setSearchParams({ ...params})
            setFilterCheckBox([])
        }
        getCount(type)
        // getInwardTransferStudentListAPICall()
        setsearchFieldDebounce(!searchParams.get('search') ? '' : decodeURIComponent(searchParams.get('search')) || '')
    }

    /**
     * The function `getInwardTransferStudentListAPICall` makes an API call to retrieve a list of
     * inward transfer students, sets the retrieved data in state variables, and handles loading and
     * error states.
     */
    /**
     * The function `getInwardTransferStudentListAPICall` makes an API call to retrieve a list of inward
     * transfer students, sets the retrieved data in state variables, and handles loading and error states.
     */
    const getInwardTransferStudentListAPICall = async () =>{
        try{
            setLoading(true)
            const branch_id = await GetBranchId()
            let endpoint = `transfer-students?inward_list=true&branch_id=${branch_id}&page_number=${
                searchParams?.get('page_number')===null ? '1' : searchParams?.get('page_number')}${
                searchParams?.get('search') === null ?"": `&search=${searchParams?.get('search')}`}${
                filterCount !== 0 ? `&filter=true${
                    searchParams?.get('start_date') === null ? "" : `&start_date=${searchParams?.get('start_date')}`}${
                    searchParams?.get('end_date') !== null ? `&end_date=${searchParams?.get('end_date')}` : ""}`: ''}` ;
            const response = await dataService.GetAPI(endpoint)
            const temp = response?.data?.data?.data || []
            const temp2 = response?.data?.data?.total_count || 0
            const temp3 = response?.data?.data?.all_total_count || 0
            setInwardTransferStudentList(temp)
            setInwardTransferStudentCount(temp2)
            setInwardTransferStudentTotalCount(temp3)
        } catch(error) {
            console.log(error)
            setInwardTransferStudentList([])
            setInwardTransferStudentCount(0)
            // setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
        } finally{
            setLoading(false)
            updateFilterCheckBox();
        }
    }

    /* The `useEffect` hook is used to perform side effects in a functional component. In this case, the
    `useEffect` hook is used to make an API call to fetch the inward transfer student list when the
    `searchParams` dependency changes. */
    useEffect(()=>{
        getInwardTransferStudentListAPICall()
    },[searchParams])

    return (
        <div class="scroll-bar tabbedPgListDiv">
            <div className='flex justify-end items-center'>
                { <TopBar 
                    SearchInput={true}
                    SearchValue={searchFieldDebounce}
                    handleOnClickSearch={setsearchFieldDebounce}
                    ApplyFilter={true}
                    handleApplyFilter={handleApplyFilter}
                    FilterCheckbox={FilterCheckbox}
                    setFilterCheckBox={setFilterCheckBox}
                    FilterData={FilterData}
                    setFilterData={setFilterData}
                    filterCount={filterCount}
                    searchParams={searchParams}
                    firstFilter={"status"}
                    radioButton
                    optimizedFn={optimizedFn}
                    customPaddingBottomForMainDiv={'5px'}
                    customSearchPlaceHolder={'Transfer ID'}
                    customSearchBarWidth={'250px'}
                    dateRangeFilterName={'Processed Date'}
                    filterFromPage={'Transfer_Inwards'}
                />}
                {toastErrorMessage !== "" && (
                    <Toast
                        message={toastErrorMessage}
                        type="error"
                        setToastmessage={setToastErrorMessage}
                    />
                )}
            </div>
            { loading ? <div className='mt-1'><Shimmer/> </div>
                : <Table  inwardTransferStudentList={inwardTransferStudentList} setPageLoading={setLoading} searchParams={searchParams} setSearchParams={setSearchParams} inwardTransferStudentCount={inwardTransferStudentCount} 
                />
            }
        </div>
    )
}
